import React            from "react";
import PropTypes        from "prop-types";
import Flux             from "../../flux/Flux";
import VideoTile        from "../Grid2/Tiles/VideoTile";
import Grid2            from "../Grid2/Grid2";
import withVideos       from "../HigherOrderComponents/Videos/withVideos";
import withWindowWidth  from "../HigherOrderComponents/Utility/withWindowWidth";
import withStaticLoader from "../HigherOrderComponents/Utility/withStaticLoader";

const TilePadding = Flux.Constants.Grid2.TilePadding;

class VideoStationGrid extends React.PureComponent {
	constructor(props) {
		super(props);
	}

	render() {
		if (!this.props.videos) {
			return null;
		}

		let videos    = [...this.props.videos];
		const columns = {xs: 2, sm: 3, md: 4, lg: 4};


		// only pass enough videos to fill full rows (only works when all tiles are size 1)
		let videoAmountToRemove = 0;
		for (const breakpoint of Flux.Constants.Grid2.BREAKPOINTS_SMALL_TO_LARGE) {
			if (this.props.windowWidth >= Flux.Constants.Grid2.BREAKPOINT_MIN_WIDTHS[breakpoint] && columns[breakpoint] && videos.length > columns[breakpoint]) {
				videoAmountToRemove = videos.length % columns[breakpoint];
			}
		}

		if (videoAmountToRemove !== 0) {
			videos = videos.splice(0, (videos.length - videoAmountToRemove));
		}

		return (
			<Grid2 tileData={videos}
			       defaultTileClass={VideoTile}
			       columns={columns}
			       defaultTileConfig={{badges: {textBadges: {show: {price: Flux.Guest.isLoggedIn(), new: false}}}}}
			       tilePadding={TilePadding.SMALL}
				   lazyImageLoading={this.props.lazyImageLoading}
				   headlineType={this.props.headlineType}
			/>
		);
	}
}

VideoStationGrid.propTypes = {
	videos:           PropTypes.array.isRequired,
	loading:          PropTypes.bool.isRequired,
	windowWidth:      PropTypes.number.isRequired,
	lazyImageLoading: PropTypes.bool,
	headlineType:     PropTypes.oneOf(Object.values(Flux.Constants.Headlines)),
};

VideoStationGrid.propTypes = {
	lazyImageLoading: false,
};


export default withWindowWidth(withVideos(withStaticLoader(VideoStationGrid)));
